import { render, staticRenderFns } from "./ArticleTransferDialog.vue?vue&type=template&id=634dd01c&"
import script from "./ArticleTransferDialog.vue?vue&type=script&lang=ts&"
export * from "./ArticleTransferDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTransferDialog.vue?vue&type=style&index=0&id=634dd01c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports